// extracted by mini-css-extract-plugin
module.exports = {"root":"AnswerScale_root__G_qhe","options":"AnswerScale_options__sgrP2","selected":"AnswerScale_selected__3B-Cz"};